import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { POST_URL } from '@utils/api/endpoints';

export interface CustomerPayload {
  first_name: string;
  last_name: string;
  email: string;
  roles?: string[];
}

export function useCreateCustomer(customerId: string) {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: CustomerPayload) => {
      const url = POST_URL(customerId).createResellerUser;
      const response = await Axios.post(url, payload);
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('resellerCustomerLogin');
      },
      useErrorBoundary: false
    }
  );
}
